<template>
    <div class="contact-header">
      <h3>The Washington-McLaughlin</h3>
      <div class="contact-header-redline">
        <h3>Adult Medical Day Care Center</h3>
      </div>
      <h3>6501 Poplar Avenue</h3>
      <h3>Tacoma Park, Maryland</h3>
      <h3>(667) 200-6325</h3>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ContactHeader'
  }
  </script>
  
  <style scoped>

/* for desktop */
@media (min-width:701px) {

  .contact-header {
    text-align: center;
    color: blue;
    font-size: 1.4rem;
    line-height: 0.7rem;
    height: auto;
    margin-top: 3vw;
    margin-bottom: 3vw;
  }

  .contact-header-redline {
    text-align: center;
    color: red;
  }
}


/* for Phone */
@media (max-width:700px) {

  .contact-header {
    text-align: center;
    width: 100vw;
    height: auto;
    color: blue;
    font-size: 1rem;
    line-height: 0.5rem;
  }

}

  </style>